import shop from "./modules/shop";
import sales from "./modules/sales";
import statistics from "./modules/statistics";
import pos from "./modules/pos";
import warehouses from "./modules/warehouses"
import stocks from "./modules/stocks";
import supplie from "./modules/supplie";

export default {
    modules: {
        shop,
        sales,
        statistics,
        pos,
        warehouses,
        stocks,
        supplie
    }
}
